export enum ERROR_TYPE {
  AUTHENTICATION_FAILED = "AuthenticationFailed",
  CML_LOAD_FAILED = "CmlLoadFailed",
  COMPONENT_ERROR = "ComponentError",
  EDLOS_LOAD_FAILED = "EdLosLoadFailed",
  GENERIC_ERROR = "GenericError",
  INCENTIVE_UNAVAILABLE_FOR_PERIOD = "IncentiveUnavailableForPeriod",
  INCORRECT_ACCOUNT = "IncorrectAccount",
  NOT_AUTHORIZED = "NotAuthorized",
  PAGE_UNAVAILABLE = "PageUnavailable",
  SYSTEM_MAINTENANCE = "SystemMaintenance",
  UNSUPPORTED_BROWSER = "UnsupportedBrowser",
  USER_SESSION_EXPIRED = "UserSessionExpired",
  NO_DOWNLINES = "NoDownlines",
}

export enum IconType {
  Question,
  Frown,
  AmwayLogo,
  Globe,
  Unavailable,
  Clock,
  Lock,
  General,
  SearchCriteria,
}
